import { render, staticRenderFns } from "./PoolClash.vue?vue&type=template&id=c4d6f6aa"
import script from "./PoolClash.vue?vue&type=script&lang=js"
export * from "./PoolClash.vue?vue&type=script&lang=js"
import style0 from "./PoolClash.vue?vue&type=style&index=0&id=c4d6f6aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports